import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=5d887c4f&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=5d887c4f&prod&lang=scss&scoped=true"
import style1 from "./Chat.vue?vue&type=style&index=1&id=5d887c4f&prod&scoped=true&lang=css"
import style2 from "./Chat.vue?vue&type=style&index=2&id=5d887c4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d887c4f",
  null
  
)

export default component.exports